export const copyToClipboard = async (textToCopy: string) => {
	if (navigator.clipboard) {
		try {
			await navigator.clipboard.writeText(textToCopy);
		} catch (error) {
			console.error('Copy error:', error);
		}
	} else {
		const tempTextArea = document.createElement('textarea');
		tempTextArea.value = textToCopy;
		document.body.appendChild(tempTextArea);
		tempTextArea.select();
		document.execCommand('copy');
		document.body.removeChild(tempTextArea);
	}
};
